export const STATUS_META = {
  not_started: { label: "Not started", icon: "bx-circle", color: "secondary", className: "mr-status--not-started" },
  in_progress: { label: "In progress", icon: "bx-time-five", color: "warning", className: "mr-status--in-progress" },
  reviewed: { label: "Reviewed", icon: "bx-check-circle", color: "success", className: "mr-status--reviewed" },
  updated: { label: "Updated – review needed", icon: "bx-revision", color: "primary", className: "mr-status--updated" },
}

export const CONTENT_TYPE_META = {
  pdf: { label: "PDF", icon: "bxs-file-pdf" },
  video: { label: "Video", icon: "bx-video" },
  html: { label: "Page", icon: "bx-code-alt" },
}

export function getStatusMeta(status) {
  return STATUS_META[status] || STATUS_META.not_started
}

export function getDisplayStatus(item) {
  if (item?.updated && item.status !== "reviewed") return "updated"
  return item?.status
}
